module.exports = __webpack_public_path__ + "static/media/black-bg.fdf21b2c.jpeg";